<template>
	<div class="case">
		<div class="content">
			<div class="title">服务案例</div>
			<div class="caseContent flex-column">
				<vue-seamless-scroll :data="list.slice(0, 8)" class="seamless-warp size" :class-option="classOption1">
					<div class="list flex-center flex-row">
						<div class="item" v-for="(item, index) in list.slice(0, 8)" :key="index">
							<div class="img flex-row flex-center "><img :src="item" alt="" /></div>
						</div>
					</div>
				</vue-seamless-scroll>
				<vue-seamless-scroll :data="list.slice(8, 16)" class="seamless-warp size" :class-option="classOption2">
					<div class="list flex-center flex-row">
						<div class="item" v-for="(item, index) in list.slice(8, 16)" :key="index">
							<div class="img flex-row flex-center "><img :src="item" alt="" /></div>
						</div>
					</div>
				</vue-seamless-scroll>
				<!-- <div class="list flex-row">
					<div class="item " v-for="(item, index) in list.slice(0, 5)" :key="index">
						<div class="img flex-row flex-center"><img :src="item" alt="" /></div>
					</div>
				</div>
				<div class="list flex-row">
					<div class="item" v-for="(item, index) in list.slice(5, 10)" :key="index">
						<div class="img flex-row flex-center"><img :src="item" alt="" /></div>
					</div>
				</div>
				<div class="list flex-row">
					<div class="item " v-for="(item, index) in list.slice(10, 15)" :key="index">
						<div class="img flex-row flex-center"><img :src="item" alt="" /></div>
					</div>
				</div>
				<div class="list flex-row">
					<div class="item" v-for="(item, index) in list.slice(15, 20)" :key="index">
						<div class="img flex-row flex-center "><img :src="item" alt="" /></div>
					</div>
				</div> -->
				<vue-seamless-scroll :data="list.slice(16, 24)" class="seamless-warp size" :class-option="classOption3">
					<div class="list flex-center flex-row">
						<div class="item" v-for="(item, index) in list.slice(16, 24)" :key="index">
							<div class="img flex-row flex-center "><img :src="item" alt="" /></div>
						</div>
					</div>
				</vue-seamless-scroll>
			</div>
		</div>
		<div style="height: 192px"></div>
	</div>
</template>

<script>
import vueSeamlessScroll from 'vue-seamless-scroll';
import { WOW } from 'wowjs';
export default {
	components: {
		vueSeamlessScroll
	},
	computed: {
		classOption1() {
			return {
				step: 0.5, // 数值越大速度滚动越快
				limitMoveNum: 6, // 开始无缝滚动的数据量 this.dataList.length
				hoverStop: true, // 是否开启鼠标悬停stop
				direction: 2, // 0向下 1向上 2向左 3向右
				openWatch: true, // 开启数据实时监控刷新dom
				singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
				singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
				waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
			};
		},
		classOption2() {
			return {
				step: 0.2, // 数值越大速度滚动越快
				limitMoveNum: 6, // 开始无缝滚动的数据量 this.dataList.length
				hoverStop: true, // 是否开启鼠标悬停stop
				direction: 2, // 0向下 1向上 2向左 3向右
				openWatch: true, // 开启数据实时监控刷新dom
				singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
				singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
				waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
			};
		},
		classOption3() {
			return {
				step: 0.5, // 数值越大速度滚动越快
				limitMoveNum: 6, // 开始无缝滚动的数据量 this.dataList.length
				hoverStop: true, // 是否开启鼠标悬停stop
				direction: 2, // 0向下 1向上 2向左 3向右
				openWatch: true, // 开启数据实时监控刷新dom
				singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
				singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
				waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
			};
		}
	},
	mounted() {
		this.$nextTick(() => {
			// 在dom渲染完后,再执行动画
			var wow = new WOW({
				live: false,
				offset: 100
			});
			wow.init();
		});
	},
	methods: {
		change(index) {
			this.activeBar = index;
		},
		rollTemp() {
			let all = 0;
			let count = this.$refs.temp.childElementCount;
			for (let i = 0; i < count; i++) {
				all += this.$refs.temp.children[i].offsetWidth;
			}
			let half = all >> 1;
			if (x < 1 - half) {
				x = 0;
			}
			x -= 2;
			this.$refs.temp.style.transform = 'translateX(' + x + 'px)';
		}
	},
	destroyed() {
		clearInterval(this.tempInterval);
	},

	data() {
		return {
			tempInterval: undefined,
			activeBar: 0,
			list: [
				require('@/assets/home/case/case1.png'),
				require('@/assets/home/case/case2.png'),
				// require('@/assets/home/case/case3.png'),
				require('@/assets/home/case/case4.png'),
				require('@/assets/home/case/case5.png'),
				require('@/assets/home/case/case6.png'),
				require('@/assets/home/case/case7.png'),
				require('@/assets/home/case/case8.png'),
				require('@/assets/home/case/case9.png'),
				require('@/assets/home/case/case10.png'),
				require('@/assets/home/case/case11.png'),
				require('@/assets/home/case/case12.png'),
				require('@/assets/home/case/case13.png'),
				require('@/assets/home/case/case14.png'),
				require('@/assets/home/case/case15.png'),
				require('@/assets/home/case/case16.png'),
				require('@/assets/home/case/case17.png'),
				require('@/assets/home/case/case18.png'),
				require('@/assets/home/case/case19.png'),
				require('@/assets/home/case/case20.png'),
				require('@/assets/home/case/case21.png'),
				require('@/assets/home/case/case22.png'),
				require('@/assets/home/case/case23.png'),
				require('@/assets/home/case/case24.png'),
				require('@/assets/home/case/case25.png')
			]
		};
	}
};
</script>

<style lang="scss" scoped>
.seamless-warp {
	width: 1200px;
	overflow: hidden;
}
.title {
	margin: 0 auto;
	text-align: center;
	height: 45px;
	font-size: 32px;
	font-weight: 600;
	color: #333333;
	margin-bottom: 74px;
}
.caseContent {
	width: 100%;
	height: 390px;
	justify-content: space-evenly;
	// background-color: red;
	.list {
		height: 124px;
		justify-content: space-between;
	}
	.item {
		box-shadow: 0 5.18771px 20px rgb(19 60 154 / 8%), inset 0 2px 0 #fff;
		margin: 30px 16px; 
		width: 224px;
		height: 100px;
		border-radius: 8px;
		.img {
			overflow: hidden;
			border-radius: 8px;
			width: 224px;
			height: 100px;
		}
		
	}
}
.case {
	
	background: #ffffff;
}
.lightspot::before {
	content: '';
	display: table;
}
.content {
	margin: 0 auto;
	margin-top: 105px;
	width: $global-content-width;
}
</style>
